import React from 'react'
import Skeleton from "react-loading-skeleton";
import { PlanIcon } from '../Assets/Icons';


const PlanSkeleton = ({length = 5}) => {
  return (
    <>
      {Array.from({ length: length}).map((_, index) => (
                      <div className={`plan-item`}>
                        <div className="plan-name-info">
                          <span className="icon-here">
                            <PlanIcon />
                          </span>
                          <div className="name-info">
                            <h6>
                              <Skeleton width="15rem" height="100%" />
                            </h6>
                            <div className="resource-info">
                              <p>
                                <Skeleton width="10rem" height="100%" />
                              </p>
                              <p>
                                <Skeleton width="10rem" height="100%" />
                              </p>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="plan-price">
                            <p>
                              <Skeleton width="6rem" height="2rem" />
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
    </>
  )
}

export default PlanSkeleton
